import type { CustomGridState } from '@/components/Grid/Classes/CustomGridState';
import { SettingsBase } from './SettingsBase';

export class GridStateSettings extends SettingsBase {
    static NAME_OF_CLASS = 'GridStateSettings';
    public gridStates: CustomGridState[] = [];

    public constructor(val?: GridStateSettings) {
        super();
        this.gridStates = val?.gridStates ?? [];
    }
}
